<template>
    <div class="business-pilot-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Streamline your operations with ONE solution: Business Pilot
                </div>
                <div class="logo">
                    <img src="/images/business-pilot-header-logo.png">
                </div>
            </div>
            <div class="highlight-bar" @click="enquiry_box_open = true">
                <h1>Get 25% off license fee</h1>
            </div>
            <div class="box-1">
                <h1><a href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">Built for installers by installers</a></h1>
                <p>
                    Business Pilot is the simple system that’s designed to improve your business performance. So much more than just a CRM, Business Pilot streamlines your operations, helps you manage leads and sales, schedule installations,
                    manage your finances all in the same platform.
                </p>
                <p>
                    Business Pilot is already used by hundreds of retail installation companies who use the software system to manage window, door and conservatory projects.
                </p>
                <h3>
                    <a href="https://www.youtube.com/watch?v=JGE1PFlji6o&list=PLlTHoqOZjklN6lR3GKFV9TZv_pnYN2pyi" target="_blank">See what Business Pilot installers say about the software <u>here</u>.</a>
                </h3>
                <p>
                    <a class="btn-primary _lg" @click="enquiry_box_open = true">
                        <strong>Make Enquiry</strong>
                    </a>
                </p>
            </div>
            <div class="overlapping-image">
                <video controls>
                    <source src="https://epwin-portal.s3.eu-west-2.amazonaws.com/business-pilot.mov" type="video/mp4">
                    <source src="https://epwin-portal.s3.eu-west-2.amazonaws.com/business-pilot.mov" type="video/quicktime">
                </video>
            </div>
            <div class="box-2">
                <p>
                    We’ve partnered with Business Pilot to bring you an <strong>exclusive 25% off license fee</strong> to take your business to the next level.
                </p>
                <p>
                    Still not sure? Business pilots are here to help. Start a <strong>free trial</strong> with pre-loaded demo data so you can see how the system works immediately.
                </p>
                <div>
                    <a class="btn-primary-outline _lg" @click="enquiry_box_open = true">
                        <strong>Try for free</strong>
                    </a>
                    <a class="btn-primary _lg" @click="enquiry_box_open = true">
                        <strong>Get 25% off</strong>
                    </a>
                </div>
            </div>
            <div class="box-3 main _image-left">
                <div class="image">
                    <a href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">
                        <img src="/images/installer-benefits-landing-page-business-pilot-1.png">
                    </a>
                </div>
                <div class="content">
                    <div>
                        <div>
                            <h2>
                                <a class="txt-primary" href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">
                                    Leads and sales process management
                                </a>
                            </h2>
                        </div>
                        <ul>
                            <li><strong>BPsign, NEW for 2025</strong> <span class="txt-sm">(electronic signature)</span></li>
                            <li><strong>Manage Sales Processes and paperwork</strong></li>
                            <li><strong>Manage Service Calls & History</strong></li>
                            <li><strong>Web to Lead Integration</strong></li>
                            <li><strong>BPmail</strong> <span class="txt-sm">(integrated email system)</span></li>
                            <li><strong>Management Dashboards & Exports</strong></li>
                        </ul>
                        <p>
                            <a class="btn-primary _lg" @click="enquiry_box_open = true">
                                <strong>Get Started For Free</strong>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="box-4 main _image-right">
                <div class="image">
                    <a href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">
                        <img src="/images/installer-benefits-landing-page-business-pilot-2.png">
                    </a>
                </div>
                <div class="content">
                    <div>
                        <div>
                            <h2 class="">
                                <a href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">
                                    Job scheduling
                                </a>
                            </h2>
                        </div>
                        <ul>
                            <li><strong>Live, Interactive Scheduling</strong></li>
                            <li><strong>Manage Contracts</strong></li>
                            <li><strong>BPsite App</strong> <span class="txt-sm">(app version)</span></li>
                            <li><strong>Stock Management</strong></li>
                            <li><strong>Tasks Management & Status Progression</strong></li>
                            <li><strong>BPSite Report Form, NEW for 2025</strong></li>
                        </ul>
                        <div class="mt-6">
                            <a class="btn-primary-outline _lg" @click="enquiry_box_open = true">
                                <strong>Get Started For Free</strong>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-5 main _image-left">
                <div class="image">
                    <a href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">
                        <img src="/images/installer-benefits-landing-page-business-pilot-3.png">
                    </a>
                </div>
                <div class="content">
                    <div>
                        <div>
                            <h2>
                                <a class="txt-primary" href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">
                                    Finances
                                </a>
                            </h2>
                        </div>
                        <ul>
                            <li><strong>Manage your Finances in one platform</strong> <br> <span class="txt-sm">(purchase orders, payments, accounts system)</span></li>
                            <li><strong>Purchase Control</strong></li>
                            <li><strong>Seamless integration with to Other Tools</strong> <br> <span class="txt-sm">(API links with Xero, Windowlink & more)</span></li>
                            <li><strong>Document Templates</strong></li>
                        </ul>
                        <p>
                            <a class="btn-primary _lg" @click="enquiry_box_open = true">
                                <strong>Get Started For Free</strong>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        <div class="box-6 main">
            <div class="content">
                <div>
                    <div>
                        <h2>
                            <a href="https://businesspilot.co.uk/epwin-group/" target="_blank" @click="partnerLinkClicked()">
                                Business Pilot API Integrations
                            </a>
                        </h2>
                    </div>
                    <p>
                        Business Pilot has teamed up with some of the best organisations in the glazing industry to
                        help make life even easier for you.
                    </p>
                    <p>
                        The system has an API link with FENSA, so you can send job information direct to the FENSA
                        system for self-certification, with one click of a button.
                    </p>
                    <p>
                        <img src="/images/installer-benefits-landing-page-business-pilot-fensa.png">
                    </p>
                    <p>
                        The API link with Windowlink means designs and surveys can be sent direct to the Business Pilot
                        system from their Focus and Vector glazing design software.
                        For taking care of finance, there’s a direct API link with Xero and Blink Payment too.
                    </p>
                    <p>
                        <img src="/images/installer-benefits-landing-page-business-pilot-window-link.png">
                    </p>
                    <div>
                        <h2>
                            Business Pilot Export Links
                        </h2>
                    </div>
                    <p>
                        If you don’t use those tools, Business Pilot also has an Export function
                        to reduce the time spent inputting data into other systems. Exports are available for Certass
                        self-certification and for finance, there’s a direct integration with Xero,
                        plus export function options for both Sage and QuickBooks.
                    </p>
                </div>
            </div>
        </div>
        <div class="box-7 main">
            <div class="content">
                <div>
                    <div>
                        <h2 class="txt-primary">
                            Special Offer for You
                        </h2>
                    </div>
                    <p>
                        Epwin Window Systems’ customers are entitled to a special offer too.
                        You can get 25% off your licenses for the first six months of your Business Pilot subscription, to help you get up and running.
                        If you’re still not convinced, you can try it for free – request your free trial direct from Business Pilot.
                    </p>
                    <div>
                        <a class="btn-primary-outline _lg" @click="enquiry_box_open = true">
                            <strong>Try for free</strong>
                        </a>
                        <a class="btn-primary _lg" @click="enquiry_box_open = true">
                            <strong>Get 25% off</strong>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Business Pilot Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
    props: [
        'logged_in_user',
    ],
    components: {
      vueVimeoPlayer
    },
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like more information on signing up for Business Pilot',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 57,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Business Pilot enquiry',
                'value': 'Business Pilot enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Business Pilot`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Business Pilot partner link clicked',
          'value': 'Business Pilot partner link clicked',
        });
      },
    },
};
</script>
